import React from 'react';
import { Link } from "react-router-dom";
import WhatsappIcon from '@/assets/images/svg/whatsapp-icon.svg';

const WhatsappChat = () => {
  return (
    <div>
        {/* <a 
        href='https://www.google.com/'
        target='_blank'
        rel='noreferrer'
        className="whatsapp-chat">
        <img src={WhatsappIcon} alt='whatsapp-icon' />
        </a> */}
        <Link to={`https://api.whatsapp.com/send/?phone=919898116349&text&type=phone_number&app_absent=0`} className="whatsapp-chat" title="whatsapp"
            target={"_blank"}
            rel={"noopener noreferrer"}>
              <img src={WhatsappIcon} alt='whatsapp-icon' />
        </Link>
    </div>
  )
}

export default WhatsappChat
